<template>
<m-pageframe
    title="RedChirp: Help and Tutorials"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
        <v-menu
            bottom
            offset-y
            slot="append-outer"
            v-if="$rc.$state.isAuthActorSystemAdmin()"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>

            <v-list>
                <m-restricted-menu-list-item
                    v-on:click="doUpdate()"
                    text="Refresh"
                />

                <v-divider/>

                <m-restricted-menu-list-item
                    v-on:click="onClickSync()"
                    text="Sync..."
                />
            </v-list>
        </v-menu>
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        class="elevation-1"

        :options.sync="table_options"
        :items-per-page="50"

        :footer-props="{
            showFirstLastPage: true,
            itemsPerPage: 50,
            disableItemsPerPage: true,
            itemsPerPageOptions: [50, 100],
        }"

        :server-items-length="result_count"

        v-on:click:row="onClickRow"
    >
        <template v-slot:header.action v-if="$rc.$state.isAuthActorSystemAdmin()">
            <m-restricted-table-header-cell text="Action" />
        </template>

        <template v-slot:item.title="{ item }">
            <span v-html="item.title"/>
        </template>

        <template v-slot:item.time_last_modified_date="{ item }">
            {{$rc.pretty(item.time_last_modified, 'date')}}
        </template>

        <template v-slot:item.time_last_modified_time="{ item }">
            {{$rc.pretty(item.time_last_modified, 'time')}}
        </template>

        <template v-slot:item.view="{ item }">
            <v-icon
                v-on:click="onClickRow(item)"
            >
                mdi-open-in-new
            </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu
                bottom
                offset-y
            >

            <template v-slot:activator="{ on }">

                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>

            </template>

            <v-list>

                 <v-list-item
                    v-on:click="onClickCopyUrl(item)"
                >
                    <v-list-item-title>Copy url</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickCopyPermalink(item)"
                >
                    <v-list-item-title>Copy permalink</v-list-item-title>
                </v-list-item>

            </v-list>

            </v-menu>

        </template>

    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: null,
            table_options: null,
            result_count: 0,
        }
    },


    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            let sort_column_map = {
                'time_last_modified_date': 'time_last_modified',
                'time_last_modified_time': 'time_last_modified',
            };

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/help',

                'params' : {
                        ...this.$rc.parseVTableOptions(this.table_options, 'time_last_modified_:desc|title_|id_', sort_column_map),
                        'full_text': this.full_text,
                    },

                'on_success': (data) => {
                        this.results = data.results;
                        this.result_count = data.result_count;
                    },

                'on_error': 'Unable to complete API call',
            });
        },

        onClickRow(item)
        {
            window.open(item.url,'_blank');
        },

        onClickSync()
        {
            this.$rc.confirm({
                'title': 'Sync Help Content',
                'body': 'You are about to re-sync help content with RedChirp\'s CMS systems (WordPress, Vimeo, etc.).<br/><br/>This is safe to do at any time (RedChirp does this automatically every 15 minutes).<br/><br/>Remember to click "Purge SG Cache" in wordpress first (or your changes may not show up).<br/><br/>A sync takes a few minutes.  Refresh after waiting to see your changes.',
                'btn_text_ok': 'Sync Now',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.doSync();
                },
            });
        },

        doSync()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/help/sync',

                'params' : {
                    },

                'on_success': (data) => {
                        this.$rc.snackbar("Sync started.  This may take a few moments.");
                    },

                'on_error': 'Unable to resync',
            });
        },

        onClickCopyUrl(item)
        {
            this.$rc.copy(item.url);
            this.$rc.snackbar("Copied url to clipboard");
        },

        onClickCopyPermalink(item)
        {
            let url = item.permalink;
            if ( url == null ) url = item.url;

            this.$rc.copy(url);
            this.$rc.snackbar("Copied permalink to clipboard");
        },
    },

    computed: {
        headers() {
             let ret = [];


            ret.push({ text: 'Date', value: 'time_last_modified_date'});
            ret.push({ text: 'Time', value: 'time_last_modified_time'});
            ret.push({ text: 'Title', value: 'title'});

            if ( this.$rc.$state.isAuthActorSystemAdmin() )
                ret.push({ text: 'Action', value: 'action', sortable: false});
            else
                ret.push({ text: 'View', value: 'view'});

            return ret;
        }
    },

    watch: {
        table_options(newValue, oldValue) {
            this.doUpdate();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>